export const APROVAR_MUT_DATA_INICIAL = 'MUTATION__001'
export const APROVAR_MUT_DATA_FINAL = 'MUTATION__002'
export const APROVAR_MUT_LOCALEXECUCAO = 'MUTATION__003'

export const APROVAR_DIS_LISTAR = 'DISPATCH__001'
